import { cx } from "@emotion/css";
import List from "@mui/material/List";

function OptionsContainer(props) {
	return (
		<List
			id="menu-list"
			className={cx("question-options-list", props.className)}
		>
			{props.children}
		</List>
	);
}

export default OptionsContainer;
